"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOfficesAgendasListApiSchema = void 0;
const zod_1 = require("zod");
const address_schema_1 = require("../global/address.schema");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const officeAgendaItemApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string(),
    type: (0, api_1.apiEntityTypeSchema)('offices'),
    attributes: zod_1.z.object({
        name: zod_1.z.string(),
        address: address_schema_1.addressSchema,
        createdAt: zod_1.z.coerce.date(),
    }),
});
exports.getOfficesAgendasListApiSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(officeAgendaItemApiResponseSchema);
